import { IFaq, IFaqSearchParams, ITheme } from '../Models';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const FaqService = {
    async getAllFaq(searchParams: IFaqSearchParams): Promise<IFaq[]> {
        const response = await fetch('/Api/Faqs/GetAll', {
            method: 'POST',
            body: JSON.stringify(searchParams),
            headers,
        });
        return await response.json();
    },
    async getAllThemes(configId: number | null): Promise<ITheme[]> {
        const response = await fetch(
            '/Api/Faqs/GetAllThemes?configId=' + configId,
            {
                method: 'Get',
                headers,
            }
        );
        return await response.json();
    },
};
